import {useState} from "react";

export default function FormControl({label, type, value, disabled, onChange, className, ref, placeholder, variant}) {

    let [id] = useState((Math.random() + 1).toString(36).substring(7));
    const inputClassName = variant === 'onboarding'
        ? 'w-full rounded-lg border-2 border-transparent bg-white px-4 py-4 text-sm font-medium leading-[22px] text-slate-800 shadow-sm transition duration-150 ease-in-out placeholder:text-slate-400 hover:border-slate-200 focus:border-[#8470ff] focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400'
        : 'form-input w-full';
    const labelClassName = variant === 'onboarding'
        ? 'mb-2 block text-sm font-medium text-slate-700'
        : 'block text-sm font-medium mb-1';

    return (
        <div className={className}>
            <label className={labelClassName} htmlFor={id}>{label}</label>
            <input
                id={id} className={inputClassName} value={value} type={type}
                onChange={(e) => onChange && onChange(e)}
                disabled={disabled}
                ref={ref}
                placeholder={placeholder}
            />
        </div>
    );
}
